import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-yellow-400 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <img src="https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/0cdc8a6b92ed12030230ca2c206db970.png" alt="BoxFreeMove" className="h-28 w-auto mb-4" />
            <p className="text-gray-900 text-sm">
              No boxes. No Tape. No cardboard mess. Heavy-duty moving totes delivered.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#how-it-works" className="text-gray-900 hover:text-gray-700 transition-colors text-sm">How It Works</a></li>
              <li><a href="#pricing" className="text-gray-900 hover:text-gray-700 transition-colors text-sm">Pricing</a></li>
              <li><a href="#faq" className="text-gray-900 hover:text-gray-700 transition-colors text-sm">FAQ</a></li>
              <li><a href="#booking-form" className="text-gray-900 hover:text-gray-700 transition-colors text-sm">Reserve Now</a></li>
              <li><Link to="/moving-tips" className="text-gray-900 hover:text-gray-700 transition-colors text-sm">Moving Tips</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Contact</h4>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-900">Email: <a href="mailto:hello@boxfreemove.com" className="hover:underline cursor-pointer">hello@boxfreemove.com</a></li>
              <li className="text-gray-900">Phone: (616) 389-7507</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Follow Us</h4>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center hover:bg-gray-800 transition-colors">
                <i className="ri-facebook-fill text-xl text-yellow-400"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center hover:bg-gray-800 transition-colors">
                <i className="ri-instagram-line text-xl text-yellow-400"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center hover:bg-gray-800 transition-colors">
                <i className="ri-twitter-x-line text-xl text-yellow-400"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-900/20 pt-8 text-center">
          <p className="text-gray-900 text-sm">
            &copy; {currentYear} BoxFreeMove.com. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
